import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PHOTOS } from "@/lib/assets";

const SERVICES = [
  {
    num: "01",
    title: "Imagen y posicionamiento",
    desc: "Desarrollo de una identidad digital coherente con la personalidad y los objetivos de cada creadora.",
  },
  {
    num: "02",
    title: "Estrategia y planificación",
    desc: "Organización del calendario, propuestas comerciales y seguimiento del proyecto.",
  },
  {
    num: "03",
    title: "Edición y administración del contenido",
    desc: "Selección, organización y adaptación del material que la creadora entrega y autoriza.",
  },
  {
    num: "04",
    title: "Marketing y promoción",
    desc: "Creación y gestión de perfiles promocionales desde cero, mediante canales y publicaciones permitidos.",
  },
  {
    num: "05",
    title: "Gestión de cuentas",
    desc: "Organización de publicaciones, precios, ofertas y consultas mediante las funciones y accesos autorizados por las plataformas.",
  },
  {
    num: "06",
    title: "Reportes y pagos",
    desc: "Liquidaciones periódicas con ingresos, comisión, gastos aprobados y saldo correspondiente.",
  },
];

export default function Servicios() {
  return (
    <div data-testid="servicios-page">
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-mauve font-sans font-semibold">Servicios</span>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink mt-4 leading-[1.1] max-w-3xl">
              Tu proyecto, acompañado de principio a fin.
            </h1>
            <p
              data-testid="servicios-disclosure"
              className="mt-8 border-l-2 border-champagne pl-4 text-sm text-stone2 leading-relaxed max-w-2xl"
            >
              Nuestros servicios incluyen representación, gestión de imagen y administración de cuentas de
              contenido digital, con el alcance y los límites que cada creadora define por escrito. Exclusivo para
              mayores de 18 años.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line border border-line">
            {SERVICES.map((s, i) => (
              <Reveal key={s.num} delay={(i % 2) * 0.1}>
                <article
                  data-testid={`service-block-${s.num}`}
                  className="bg-ivory p-8 lg:p-12 h-full hover:bg-cream transition-colors duration-500 group"
                >
                  <span className="font-serif text-4xl text-champagne group-hover:text-dustyrose transition-colors duration-500">
                    {s.num}
                  </span>
                  <h2 className="font-serif text-2xl text-ink mt-5 leading-snug">{s.title}</h2>
                  <p className="mt-4 text-base font-light text-stone2 leading-relaxed">{s.desc}</p>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <p
              data-testid="servicios-aclaracion"
              className="mt-10 bg-cream border border-line p-6 text-sm font-light text-stone2 leading-relaxed"
            >
              Los entregables, horarios, sesiones de producción y presupuesto publicitario se definen por escrito antes
              de comenzar.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <img
                src={PHOTOS.editing}
                alt="Edición y trabajo creativo en estudio"
                data-testid="servicios-image"
                className="w-full h-[380px] sm:h-[460px] object-cover"
              />
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-ink leading-[1.15]">
                Una operación organizada, pensada para ti.
              </h2>
              <p className="mt-6 text-base font-light text-stone2 leading-relaxed">
                Cada servicio se activa según lo acordado en tu proyecto. Tú defines los límites, el contenido que
                autorizas y los canales de promoción; nuestro equipo se encarga de la gestión profesional.
              </p>
              <Link
                to="/como-funciona"
                data-testid="servicios-cta-como-funciona"
                className="mt-10 inline-flex items-center gap-2 bg-plum text-ivory hover:bg-mauve px-8 py-4 text-xs uppercase tracking-[0.18em] transition-colors duration-300 font-sans"
              >
                Conoce cómo funciona <ArrowRight size={15} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
